import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doPostFiles, doPutFiles, doDelete } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getSchemaProposalResponsinatorBasicInfo = (projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator`
  return doGet(url)
}

export const updateSchemaProposalResponsinatorBasicInfo = (projectId, request) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator`
  return doPut(url, request)
}

export const saveProposalResponsinatorBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/personal`
  return doPostFiles(url, request)
}

export const updateProposalResponsinatorBasicInfo = (request, projectId, personalId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/personal/${personalId}`
  return doPutFiles(url, request)
}

export const saveProposalResponsinatorCompanyBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/company`
  return doPost(url, request)
}

export const updateProposalResponsinatorCompanyBasicInfo = (request, projectId, companyId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/company/${companyId}`
  return doPut(url, request)
}

export const saveProposalQualificationResponsible = (projectId, request) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/qualification`
  return doPost(url, request)
}

export const updateProposalQualificationResponsible = (projectId, request) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/qualification/${request.id}`
  return doPut(url, request)
}

export const saveResponsinator = (projectId, request) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/project`
  return doPost(url, request)
}

export const updateResponsinator = (projectId, request) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/project/${request.id}`
  return doPut(url, request)
}

export const deleteResponsinator = (projectId, id) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/project/${id}`
  return doDelete(url)
}

export const getResponsinator = (projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/responsinator/project`
  return doGet(url)
}

// SubProject
export const getSchemaProposalResponsinatorBasicInfoSubproject = (projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator`
  return doGet(url)
}

export const updateSchemaProposalResponsinatorBasicInfoSubproject = (projectId, request) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator`
  return doPut(url, request)
}

export const saveProposalResponsinatorBasicInfoSubproject = (request, projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator/personal`
  return doPostFiles(url, request)
}

export const updateProposalResponsinatorBasicInfoSubproject = (request, projectId, personalId) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator/personal/${personalId}`
  return doPutFiles(url, request)
}

export const saveProposalResponsinatorCompanyBasicInfoSubproject = (request, projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator/company`
  return doPost(url, request)
}

export const updateProposalResponsinatorCompanyBasicInfoSubproject = (
  request,
  projectId,
  companyId
) => {
  const url = `${API_ROOT}/subproject/${projectId}/responsinator/company/${companyId}`
  return doPut(url, request)
}
